export default "/Frontend/dist/logo.cfaa494b84e876407e6789db4bbf02cb.png";